import { useEffect } from "react";

interface ThemeProviderProps {
  children: React.ReactNode;
}

const enforceLightTheme = () => {
  const root = document.documentElement;
  root.classList.remove("dark");
  root.classList.add("light");
  root.style.colorScheme = "light";
  root.setAttribute("data-theme", "light");

  try {
    localStorage.setItem("theme", "light");
  } catch {
    // ignore
  }
};

export function ThemeProvider({ children }: ThemeProviderProps) {
  useEffect(() => {
    enforceLightTheme();

    const observer = new MutationObserver(() => {
      enforceLightTheme();
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class", "style", "data-theme"],
    });

    return () => observer.disconnect();
  }, []);

  return <>{children}</>;
}
